import { MtxTooltipAnchor } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import SidebarDemoBadge from '@/components/SidebarDemoBadge/SidebarDemoBadge';
import useSidebarMenu from '@/components/SidebarMenu/useSidebarMenu';
import { UserMenuItems } from '@/constants/menu';
import useRemoveTooltipAnchorTabStop from '@/hooks/useRemoveTooltipAnchorTabStop';
import joinClassNames from '@/utils/functions/joinClassNames/joinClassNames';

import styles from './styles.module.css';

interface SidebarFooterProps {
  userMenuPlacement: 'right' | 'top-start';
  /** Called after a user menu entry is activated. Mobile passes the drawer close, desktop passes nothing. */
  onNavigate?: () => void;
}

const SidebarFooter = ({ userMenuPlacement, onNavigate }: SidebarFooterProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { user, isDemo, isUserMenuOpen, openUserMenu, closeUserMenu, selectUserMenuItem } = useSidebarMenu();
  const tooltipAnchorRef = useRemoveTooltipAnchorTabStop();

  const isDesktopPlacement = userMenuPlacement === 'right';

  return (
    <div className={styles.sidebarFooter}>
      <div className={styles.sidebarContact}>
        <a href={`tel:${t('navigation.phoneNumber')}`} className={styles.sidebarContactPhone}>
          {t('navigation.phoneNumber')}
        </a>
        <span className={styles.sidebarContactService}>{t('navigation.infoService')}</span>
      </div>

      <div className={styles.sidebarUserMore}>
        <MtxTooltipAnchor
          ref={tooltipAnchorRef}
          placement={userMenuPlacement}
          className={styles.sidebarUserTooltipAnchor}
          onDisplay={openUserMenu}
          onHide={closeUserMenu}
        >
          <button type="button" className={styles.sidebarUser}>
            <div className={styles.sidebarUserAvatar}>
              <span>{user?.prenom?.charAt(0) || ''}</span>
              <span>{user?.nom?.charAt(0) || ''}</span>
            </div>
            <div
              className={joinClassNames(
                styles.userName,
                isUserMenuOpen ? styles.sidebarUserNameActive : styles.sidebarUserName
              )}
            >
              <span>{user?.prenom}</span>
              <span>{user?.nom}</span>
            </div>
            <div className={styles.sidebarUserButton}>
              <i className="totem-icon totem-icon-chevrons-2" />
            </div>
          </button>

          <div
            slot="content"
            className={joinClassNames(
              styles.sidebarUserMenu,
              isDesktopPlacement ? styles.sidebarUserMenuDesktop : styles.sidebarUserMenuMobile
            )}
          >
            {isDemo && <SidebarDemoBadge />}
            {UserMenuItems.map((item) => (
              <button
                type="button"
                key={item.title}
                className={joinClassNames(
                  styles.sidebarUserMenuItem,
                  item.icon === 'logout' && styles.sidebarUserMenuItemLogout,
                  location.pathname === item.path && styles.sidebarUserMenuItemActive
                )}
                onClick={(event) => {
                  event.stopPropagation();
                  selectUserMenuItem(item);
                  onNavigate?.();
                }}
              >
                <i className={`totem-icon totem-icon-${item.icon}`} />
                <span className={styles.titleItem}>{t(item.title)}</span>
              </button>
            ))}
          </div>
        </MtxTooltipAnchor>
      </div>
    </div>
  );
};

export default SidebarFooter;
